export default function setPageTitle(pageTitle) {
  document.title = pageTitle;
}
